export default __webpack_public_path__ + "static/media/AboutCard2.c02b9ebd.png";